export default "__VITE_ASSET__836cdfb5__"